module.exports = __webpack_public_path__ + "img/20250519_HMM_V1.e61a8f8e.png";